<template>
  <b-button variant="secondary" @click.stop="toggleState" :disabled="formLoading" :pressed="!file.is_needed" pill>
    <b-spinner v-if="formLoading" label="Setting..."></b-spinner>
    <span v-else>{{ buttonText }}</span>
  </b-button>
</template>

<script>
import mediaMixin from '@/views/admin/media/mediaMixin';

export default {
  mixins: [mediaMixin],
  data() {
    return {
      formLoading: false,
    };
  },
  props: {
    // this is our initial data source
    file: {
      type: [Object],
      required: false,
      default: null,
    },
  },
  methods: {
    toggleState() {
      const is_needed = this.file.is_needed === 1 ? 0 : 1;
      this.updateFile({
        id: this.file.id,
        directory_id: this.file.directory_id,
        name: this.file.name,
        is_needed,
      }, true).then((file) => {
        this.$emit('is-needed-updated', file.is_needed)
      }).catch(() => {
      })
    }
  },
  computed: {
    buttonText() {
      if (this.file.is_needed) return "Needed";
      return "Not needed";
    }
  },
};
</script>
